import { createRoute } from '@tanstack/react-router'
import { lazy } from 'react'
import type { LazyPage } from './lazy-page'
import { guardAt } from './products'
import { rootRoute } from './root'

const BoardEditorPage: LazyPage = lazy(() =>
  import('../../routes/board-editor/BoardEditorPage').then((m) => ({
    default: m.BoardEditorPage,
  })),
)

/** Where the office builds the board its screens show. */
const boardRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/board',
  beforeLoad: guardAt('/board'),
  component: BoardEditorPage,
})

export const boardRoutes = [boardRoute]
